import { render, staticRenderFns } from "./HaulageJobPage.vue?vue&type=template&id=f1c5fea2&scoped=true&"
import script from "./HaulageJobPage.vue?vue&type=script&lang=js&"
export * from "./HaulageJobPage.vue?vue&type=script&lang=js&"
import style0 from "./HaulageJobPage.vue?vue&type=style&index=0&id=f1c5fea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c5fea2",
  null
  
)

export default component.exports